export default function HeroSection() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20backdrop%20with%20warm%20golden%20and%20deep%20crimson%20ambient%20light%2C%20soft%20bokeh%20film%20reel%20texture%2C%20elegant%20movie%20projector%20glow%2C%20luxurious%20velvet%20curtain%20atmosphere%2C%20professional%20cinema%20environment%20with%20dramatic%20lighting%2C%20abstract%20film%20strip%20patterns%2C%20rich%20contrast%20and%20deep%20shadows%2C%20theatrical%20mood%2C%20no%20text%20or%20logos&width=1920&height=1080&seq=hero-bg-baiyun&orientation=landscape"
          alt="影院级影视背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/75"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 text-primary-300 text-xs font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>今日更新 128 部高清资源</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight tracking-tight">
              白云视频
              <span className="block text-primary-400 mt-1">高清影视在线平台</span>
            </h1>

            <p className="text-white/70 text-sm md:text-base leading-relaxed mt-6 max-w-xl mx-auto lg:mx-0">
              白云视频汇聚<strong className="text-white/90">97视频、丝瓜视频</strong>等同类平台的高清影视资源，
              涵盖<strong className="text-white/90">最新电影、热播电视剧、综艺节目</strong>与独家剧集。
              每日持续更新片源，全站高清在线播放不缓冲，为影迷提供一站式的免费观影体验。
              目前平台已收录<strong className="text-white/90">超过两万部影视作品</strong>，覆盖院线新片、经典老片与海外热剧。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-7 text-white/80 text-xs md:text-sm">
              <span className="flex items-center gap-1.5">
                <i className="ri-movie-2-line text-primary-400"></i>
                片库 20,000+
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-timer-flash-line text-accent-400"></i>
                每日更新
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-shield-check-line text-green-400"></i>
                高清流畅
              </span>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <button
                onClick={() => scrollTo('#carousel')}
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer"
              >
                探索专题推荐
              </button>
              <button
                onClick={() => scrollTo('#ranking')}
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-lg border border-white/30 text-white font-semibold text-sm hover:bg-white/10 transition-all duration-200 cursor-pointer"
              >
                查看热门榜单
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-1 bg-gradient-to-r from-primary-500/30 via-accent-500/20 to-primary-500/30 rounded-2xl blur-xl"></div>
              <div className="relative bg-background-950/60 backdrop-blur-sm rounded-2xl overflow-hidden border border-white/10">
                <img
                  src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20featuring%20dramatic%20film%20scenes%2C%20action%20drama%20and%20romance%20movie%20posters%20overlapping%20artistically%2C%20warm%20golden%20and%20deep%20red%20color%20palette%2C%20elegant%20film%20strip%20border%20design%2C%20theatrical%20spotlight%20effect%2C%20luxurious%20cinema%20aesthetic%2C%20professional%20movie%20promotion%20style%2C%20no%20text%20or%20watermarks&width=800&height=600&seq=hero-visual-main&orientation=landscape"
                  alt="白云视频高清影视推荐"
                  className="w-full h-auto"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                  <p className="text-white/90 text-sm font-medium">院线新片 · 热播剧集 · 综艺精选</p>
                  <p className="text-white/60 text-xs mt-1">每日更新 · 高清画质 · 流畅播放</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}